<template>
    <div style="display: flex; height: 100%;">
        <v-row style="margin: 0px;">
            <v-col cols="8" class="tableau">
                <v-data-table class="historiqueTable" :item-class="getRowClass" :items="historique"
                    :headers="headerHistorique" :items-per-page="-1" fixed-header hide-default-footer
                    @click:row="editItem">
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_historique_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click.stop="deleteItem(item)">
                            mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

            </v-col>
            <v-col cols="4" class="formulaire">
                <div class="champs">
                    <div>
                        {{ $t('_nom_') }}
                    </div>
                    <div class="input">
                        <v-text-field color="orange" outlined class="inputField" v-model="reponse.nom.value" placeholder="Ex: inv">
                        </v-text-field>
                    </div>
                </div>
                <div class="champs">
                    <div>
                        {{ $t('_type_d_onduleur_') }} (*)
                    </div>
                    <div class="inputField">
                        <select class="createSelect" v-model="reponse.type.value">
                            <option v-for="(opt, index) in onduleurs" :value="opt.modele" :key="index"> {{ opt.modele }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="champs">
                    <div>
                        {{ $t("_date_d_installation_") }} (*)
                    </div>
                    <div class="input">
                        <input class="date" type="date" v-model="reponse.dateInstall.value" />
                    </div>
                </div>
                <div v-if="this.edition === false" style="width: 50%;">
                    <div class="nom">{{ $t("_nombre_d_occurence_") }}</div>
                    <v-text-field color="orange" label="" outlined class="inputField" v-model="nbDOccurence" maxlength="2"
                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                </div>
                <v-btn v-if="!edition" :disabled="!rempli"
                    style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                    @click="addData()">
                    {{ $t('_ajouter_') }}
                </v-btn>
                <div v-else>
                    <v-btn :disabled="!rempli"
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="editData()">
                        {{ $t('_modifier_') }}
                    </v-btn>
                    <v-btn
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="cancelEdit()">
                        {{ $t('_annuler_') }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  props: {
    initHistorique: { required: false },
    onduleurs: { required: true },
    initCalepinage: { required: false },
  },

  mounted() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.reponse.dateInstall.value = `${year}-${month}-${day}`;
    this.reponseVide.dateInstall.value = `${year}-${month}-${day}`;

    if (this.initHistorique) this.historique = this.initHistorique;
    if (this.initCalepinage) this.calepinage = this.initCalepinage;
  },

  data() {
    return {
      historique: [],
      calepinage: [],
      headerHistorique: [
        { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
        { key: 'nom', text: this.$t('_nom_'), value: 'nom' },
        { key: 'type', text: this.$t('_type_d_onduleur_'), value: 'type' },
        { key: 'dateInstall', text: this.$t('_date_d_installation_'), value: 'dateInstall' },
        { key: 'actions', text: '', value: 'actions', sortable: false },
      ],
      rempli: false,
      edition: false,
      indexEdite: null,
      nbDOccurence: 1,

      reponse: {
        id: { value: "", required: false },
        nom: { value: "", required: false },
        type: { value: "", required: true },
        dateInstall: { value: "", required: true },
        dateFinExploit: { value: "", required: false }, // ✅ ajouté
      },
      reponseVide: {
        id: { value: "", required: false },
        nom: { value: "", required: false },
        type: { value: "", required: true },
        dateInstall: { value: "", required: true },
        dateFinExploit: { value: "", required: false }, // ✅ ajouté
      },
    };
  },

  methods: {
    editItem(item) {
      this.edition = true;
      this.indexEdite = this.historique.indexOf(item);
      for (let champ in item) {
        if (this.reponse[champ]) this.reponse[champ].value = item[champ];
      }
    },

    cancelEdit() {
      this.edition = false;
      this.indexEdite = null;
      this.$nextTick(() => {
        for (let champ in this.reponseVide) {
          this.reponse[champ] = Object.assign({}, this.reponseVide[champ]);
        }
      });
    },

    getRowClass(item) {
      let index = this.historique.indexOf(item);
      return index === this.indexEdite ? 'highlighted-row' : '';
    },

    editData() {
      if (this.reponse.nom.value === this.reponseVide.nom.value)
        this.reponse.nom.value = "inv-" + this.reponse.id.value;

      for (let champ in this.reponse) {
        this.historique[this.indexEdite][champ] = this.reponse[champ].value;
      }

      this.edition = false;
      this.indexEdite = null;
      this.$nextTick(() => {
        for (let champ in this.reponseVide) {
          this.reponse[champ] = Object.assign({}, this.reponseVide[champ]);
        }
      });

      this.$emit("answer", { reponse: this.historique, calepinage: this.calepinage });
    },

    addData() {
      if (this.rempli) {
        let maxId = this.historique.length > 0 
          ? Math.max(...this.historique.map(h => h.id)) 
          : 0;

        for (let i = 0; i < this.nbDOccurence; i++) {
          let justValeurs = {};
          const nouveauId = maxId + i + 1;

          if (this.reponse.nom.value === this.reponseVide.nom.value) {
            justValeurs["nom"] = "inv-" + nouveauId;
          } else if (this.nbDOccurence == 1) {
            justValeurs["nom"] = this.reponse.nom.value;
          } else {
            justValeurs["nom"] = this.reponse.nom.value + (i + 1);
          }

          for (let champ in this.reponse) {
            if (champ === "id") {
              justValeurs[champ] = nouveauId;
            } else if (champ !== "nom") {
              justValeurs[champ] = this.reponse[champ].value;
            }
          }

          this.historique.push(justValeurs);
        }

        this.$nextTick(() => {
          for (let champ in this.reponseVide) {
            this.reponse[champ] = Object.assign({}, this.reponseVide[champ]);
          }
        });

        this.nbDOccurence = 1;
        this.$emit("answer", { reponse: this.historique, calepinage: this.calepinage });
      }
    },

    deleteItem(item) {
      const index = this.historique.indexOf(item);
      if (index > -1) {
        this.historique.splice(index, 1);
      }
      this.calepinage = this.calepinage.filter(calp => calp.idOnduleur !== item.id);

      if (this.edition) {
        this.edition = false;
        this.indexEdite = null;
        this.$nextTick(() => {
          for (let champ in this.reponseVide) {
            this.reponse[champ] = Object.assign({}, this.reponseVide[champ]);
          }
        });
      }

      this.$emit("answer", { reponse: this.historique, calepinage: this.calepinage });
    },
  },

  watch: {
    reponse: {
      handler() {
        let nouveauRempli = true;
        for (let champs in this.reponse) {
          if (this.reponse[champs].required && this.reponse[champs].value === "")
            nouveauRempli = false;
        }
        this.rempli = nouveauRempli;
      },
      deep: true,
    },
    historique: {
      handler() {
        if (this.historique.length > 0) this.$emit('enable');
        else this.$emit('disable');
      },
      deep: true,
    },
  },
};
</script>


<style scoped>

.input {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    display: flex;
    align-items: center;
}

.createSelect {
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 4px;
    padding: 8px;
    outline: none;
}

.input:focus-within {
    border: none !important;
    outline: none !important;
}

.tableau {
    align-content: center;
    height: 66vh;
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
    overflow-x: auto;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.historiqueTable {
    height: 65vh;
}

.historiqueTable>>>.highlighted-row {
    background-color: #d9d9d9 !important;
}

.formulaire {
    align-content: center;
}

.v-messages {
    min-height: 0;
    height: 0;
}

.unit {
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}

.date {
    border: 1px solid #ccc; 
    transition: border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.date:focus {
    outline: none; 
    border-color: orange; 
    box-shadow: 0 0 0 1px orange; 
}
</style>